import type { EditProfileInfoDrawerProps } from './ProfileInfoDrawer';
import type { FC } from 'react';
import { EditNote } from '@eqi-investimentos/icons/web';
import { Flex, Text } from '@eqi-investimentos/react';
import { EDIT_PROFILE_INFO_DRAWER_IDS } from '../utils';

export const EditProfileInfoInput: FC<EditProfileInfoInputProps> = ({
  type,
  value,
}) => {
  return (
    <Flex
      flexDir="row"
      border="1px"
      borderColor="border.primary"
      px="l"
      py="s"
      justifyContent="space-between"
      cursor="pointer"
      borderRadius="xs"
      _hover={{
        backgroundColor: 'transparency.light',
      }}
      onClick={() =>
        window.dispatchEvent(
          new CustomEvent(
            `open-chakra-modal-${EDIT_PROFILE_INFO_DRAWER_IDS[type]}`
          )
        )
      }
    >
      <Text size="xl" color="content.tertiary">
        {value}
      </Text>
      <EditNote
        boxSize="1.25rem"
        cursor="pointer"
        _hover={{ color: 'content.brand' }}
      />
    </Flex>
  );
};

export type EditProfileInfoInputProps = Pick<
  EditProfileInfoDrawerProps,
  'type'
> & {
  value: string;
};
